import { createAction } from 'redux-act';

export const setContractModalVisible = createAction('SET_CONTRACT_MODAL_VISIBLE');
export const setContractForm = createAction('SET_CONTRACT_FORM');
export const closeContractForm = createAction('CLOSE_CONTRACT_FORM');

export const setSmsConfirmModalVisible = createAction('SET_SMS_CONFIRM_MODAL_VISIBLE');
export const setSmsConfirmForm = createAction('SET_SMS_CONFIRM_FORM');
export const closeSmsConfirmForm = createAction('CLOSE_SMS_CONFIRM_FORM');

export const setStrategyRulesModalVisible = createAction('SET_STRATEGY_RULES_MODAL_VISIBLE');
export const setStrategyRulesForm = createAction('SET_STRATEGY_RULES_FORM');
export const closeStrategyRulesForm = createAction('CLOSE_STRATEGY_RULES_FORM');

export const setBrokerSelectModalVisible = createAction('SET_BROKER_SELECT_MODAL_VISIBLE');
export const setBrokerSelectForm = createAction('SET_BROKER_SELECT_FORM');
export const closeBrokerSelectForm = createAction('CLOSE_BROKER_SELECT_FORM');

export const setBrokerConnectionModalVisible = createAction('SET_BROKER_CONNECTION_MODAL_VISIBLE');
export const setBrokerConnectionForm = createAction('SET_BROKER_CONNECTION_FORM');
export const closeBrokerConnectionForm = createAction('CLOSE_BROKER_CONNECTION_FORM');

export const setAccountSelectModalVisible = createAction('SET_ACCOUNT_SELECT_MODAL_VISIBLE');
export const setAccountSelectForm = createAction('SET_ACCOUNT_SELECT_FORM');
export const closeAccountSelectForm = createAction('CLOSE_ACCOUNT_SELECT_FORM');

export const setBrokerConnectionStatusModalVisible = createAction(
  'SET_BROKER_CONNECTION_STATUS_MODAL_VISIBLE'
);
export const setBrokerConnectionStatusForm = createAction('SET_BROKER_CONNECTION_STATUS_FORM');
export const closeBrokerConnectionStatusForm = createAction('CLOSE_BROKER_CONNECTION_STATUS_FORM');

export const setConfirmSaleModalVisible = createAction('SET_CONFIRM_SALE_MODAL_VISIBLE');
export const setConfirmSaleForm = createAction('SET_CONFIRM_SALE_FORM');
export const closeConfirmSaleForm = createAction('CLOSE_CONFIRM_SALE_FORM');

export const setBrokerConnectionSuccessModalVisible = createAction(
  'SET_BROKER_CONNECTION_SUCCESS_MODAL_VISIBLE'
);
export const setBrokerConnectionSuccessForm = createAction('SET_BROKER_CONNECTION_SUCCESS_FORM');
export const closeBrokerConnectionSuccessForm = createAction(
  'CLOSE_BROKER_CONNECTION_SUCCESS_FORM'
);

export const setRoboGoalModalVisible = createAction('SET_ROBO_GOAL_MODAL_VISIBLE');
export const setRoboGoalForm = createAction('SET_ROBO_GOAL_FORM');
export const closeRoboGoalForm = createAction('CLOSE_ROBO_GOAL_FORM');

export const setRoboReadyModalVisible = createAction('SET_ROBO_READY_MODAL_VISIBLE');
export const setRoboReadyForm = createAction('SET_ROBO_READY_FORM');
export const closeRoboReadyForm = createAction('CLOSE_ROBO_READY_FORM');

// Unified Roboadvisor Wizard actions
export const setRoboadvisorWizardModalVisible = createAction(
  'SET_ROBOADVISOR_WIZARD_MODAL_VISIBLE'
);
export const setRoboadvisorWizardForm = createAction('SET_ROBOADVISOR_WIZARD_FORM');
export const closeRoboadvisorWizard = createAction('CLOSE_ROBOADVISOR_WIZARD');

// Roboadvisor Withdraw Modal actions
export const setRoboadvisorWithdrawModalVisible = createAction(
  'SET_ROBOADVISOR_WITHDRAW_MODAL_VISIBLE'
);
export const setRoboadvisorWithdrawForm = createAction('SET_ROBOADVISOR_WITHDRAW_FORM');
export const closeRoboadvisorWithdraw = createAction('CLOSE_ROBOADVISOR_WITHDRAW');

// Roboadvisor Withdraw Success Modal actions
export const setRoboadvisorWithdrawSuccessModalVisible = createAction(
  'SET_ROBOADVISOR_WITHDRAW_SUCCESS_MODAL_VISIBLE'
);
export const setRoboadvisorWithdrawSuccessForm = createAction(
  'SET_ROBOADVISOR_WITHDRAW_SUCCESS_FORM'
);
export const closeRoboadvisorWithdrawSuccess = createAction('CLOSE_ROBOADVISOR_WITHDRAW_SUCCESS');

// Roboadvisor Disconnect Modal actions (unified modal with 3 steps)
export const setRoboadvisorDisconnectModalVisible = createAction(
  'SET_ROBOADVISOR_DISCONNECT_MODAL_VISIBLE'
);
export const setRoboadvisorDisconnectForm = createAction('SET_ROBOADVISOR_DISCONNECT_FORM');
export const closeRoboadvisorDisconnect = createAction('CLOSE_ROBOADVISOR_DISCONNECT');

// Roboadvisor Notification Detail Modal actions
export const setRoboadvisorNotificationModalVisible = createAction(
  'SET_ROBOADVISOR_NOTIFICATION_MODAL_VISIBLE'
);
export const setRoboadvisorNotificationForm = createAction('SET_ROBOADVISOR_NOTIFICATION_FORM');
export const closeRoboadvisorNotification = createAction('CLOSE_ROBOADVISOR_NOTIFICATION');

// Chat (web) modal actions – open/close globally via Redux
export const setChatModalVisible = createAction('SET_CHAT_MODAL_VISIBLE');
export const setChatModalForm = createAction('SET_CHAT_MODAL_FORM');
export const closeChatModal = createAction('CLOSE_CHAT_MODAL');
